import React, { useState } from 'react';
import { Flex, Icon } from '@chakra-ui/react';
import { animated, useTransition } from 'react-spring';

import FormLayout from 'components/form-layout';

import { SvgLogo } from 'src/components/icons';
import SignUpForm from './sign-up-form';
import Verification from './verification';

function SignUp() {
  const [userInfo, setUserInfo] = useState<{
    username: string;
    email: string;
    password: string;
  }>({
    username: '',
    email: '',
    password: '',
  });
  const [verifyStatus, setVerifyStatus] = useState(false);
  const [verifyToken, setVerifyToken] = useState('');

  const transition = useTransition(verifyStatus, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { position: 'absolute', opacity: 0 },
  });

  return (
    <FormLayout title="Sign Up - 1TM">
      <Flex mb={{ base: 2, md: 5 }} justifyContent="flex-end">
        <Icon
          as={SvgLogo}
          alt="1TM Logo"
          width="50px"
          height="20px"
          color="gray.300"
        />
      </Flex>
      {transition.map(({ item, key, props }) => (
        <animated.div key={key} style={props}>
          {item ? (
            <Verification userInfo={userInfo} verifyToken={verifyToken} />
          ) : (
            <SignUpForm
              setVerifyStatus={setVerifyStatus}
              setVerifyToken={setVerifyToken}
              setUserInfo={setUserInfo}
            />
          )}
        </animated.div>
      ))}
    </FormLayout>
  );
}

export default SignUp;
